'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  haveToggleButton: _propTypes2.default.bool,
  expanded: _propTypes2.default.bool,
  attachToRight: _propTypes2.default.bool,
  autoCollapsing: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};

var defaultProps = {
  haveToggleButton: false,
  expanded: false,
  attachToRight: false,
  autoCollapsing: false
};

/** Prop Receivers */
var width = function width(_ref) {
  var themeFromProvider = _ref.theme,
      autoCollapsing = _ref.autoCollapsing,
      expanded = _ref.expanded;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var componentPath = theme.reactackle.components.sidebar.sidebar,
      widthChangingBreakpoint = componentPath.widthChangingBreakpoint,
      zIndex = componentPath.zIndex,
      collapsedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.collapsed.width),
      expandedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.expanded.width);


  if (autoCollapsing) {
    return (0, _styledComponents.css)(['width:', ';z-index:', ';', ''], collapsedWidthValue, zIndex, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? 'width: ' + collapsedWidthValue + ';' : 'width: ' + expandedWidthValue + ';'));
  } else {
    return (0, _styledComponents.css)(['', ''], !expanded ? 'width: ' + collapsedWidthValue + ';' : 'width: ' + expandedWidthValue + ';');
  }
};

var attachToRight = function attachToRight(_ref2) {
  var attachToRight = _ref2.attachToRight;
  return attachToRight ? 'order: 2;' : '';
};

var toggleButtonBase = function toggleButtonBase(_ref3) {
  var themeFromProvider = _ref3.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var togglePath = theme.reactackle.components.sidebar.toggleButton,
      height = togglePath.height;


  return (0, _styledComponents.css)(['&::before{content:"";height:', 'px;position:fixed;top:0;left:0;', ';}'], height, (0, _reactackleCore.transition)('width, right'));
};

var toggleButtonState = function toggleButtonState(_ref4) {
  var themeFromProvider = _ref4.theme,
      expanded = _ref4.expanded,
      autoCollapsing = _ref4.autoCollapsing;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var sidebarPath = theme.reactackle.components.sidebar.sidebar,
      widthChangingBreakpoint = sidebarPath.widthChangingBreakpoint,
      collapsedWidthValue = (0, _reactackleCore.getValueString)(sidebarPath.state.collapsed.width),
      expandedWidthValue = (0, _reactackleCore.getValueString)(sidebarPath.state.expanded.width);


  var collapsedStyles = '\n    width: ' + collapsedWidthValue + ';\n  ';

  var expandedStyles = '\n    width: ' + expandedWidthValue + ';\n  ';

  if (autoCollapsing) {
    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
  } else {
    return (0, _styledComponents.css)(['', ''], expanded ? expandedStyles : collapsedStyles);
  }
};

var toggleButton = function toggleButton(_ref5) {
  var haveToggleButton = _ref5.haveToggleButton;
  return haveToggleButton ? (0, _styledComponents.css)(['', ' ', ''], toggleButtonBase, toggleButtonState) : '';
};

var base = function base(_ref6) {
  var themeFromProvider = _ref6.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

/** Styles */
var SidebarStyled = exports.SidebarStyled = _styledComponents2.default.aside.withConfig({
  displayName: 'SidebarStyled'
})(['display:block;position:relative;flex-shrink:0;z-index:2;', ';', ';', ';', ';', ';'], base, width, attachToRight, (0, _reactackleCore.transition)('width'), toggleButton);

SidebarStyled.propTypes = propTypes;
SidebarStyled.defaultProps = defaultProps;
SidebarStyled.displayName = 'SidebarStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-sidebar/dist/styles/SidebarStyled.js
// module id = 809
// module chunks = 0